export enum PartnerTypes {
  DEX = 'dex',
  VAULT = 'vault',
  YIELD_OPTIMIZER = 'yo',
  LENDING_BORROWING = 'lb',
  LEVERAGE_TADING = 'lt',
  OPTION_TADING = 'ot',
}
